var _ellipse, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsersStats = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10,
  cy: 18,
  rx: 7,
  ry: 3.5,
  stroke: "#6D727F",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 7.5,
  r: 4,
  stroke: "#6D727F",
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.878 10.997c-.23.32-.491.617-.778.886a3.5 3.5 0 1 0 1.373-6.851c.16.355.287.728.376 1.116a2.501 2.501 0 0 1-.97 4.849ZM18.986 18.333c-.04.404-.15.796-.325 1.172a8.13 8.13 0 0 0 .774-.276c.58-.24 1.08-.54 1.445-.9.366-.36.62-.81.62-1.329 0-.52-.254-.969-.62-1.33-.364-.358-.866-.658-1.445-.9-.865-.36-1.956-.611-3.162-.716a6.97 6.97 0 0 1 1.585 1.26c.442.106.842.234 1.193.38.506.211.884.45 1.127.69.241.237.322.445.322.616 0 .171-.08.38-.322.617-.243.24-.62.478-1.127.69a7.875 7.875 0 0 1-.065.026Z",
  fill: "#6D727F"
})));
export default SvgUsersStats;